import AnalyticsOutlinedIcon from '@mui/icons-material/AnalyticsOutlined';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';

const icons = {
  AnalyticsOutlinedIcon,
  TuneOutlinedIcon
};

const onm = {
  id: 'group-onm',
  title: 'O&M',
  type: 'group',
  admin: false,
  outeradmin: false,
  children: [
    {
      id: 'onm-ivscan',
      title: 'IV Curve 스캔',
      type: 'item',
      url: '/onm/ivcurvescan',
      icon: icons.AnalyticsOutlinedIcon,
      breadcrumbs: false
    }
    // {
    //   id: 'onm-outputctrl',
    //   title: '출력제어',
    //   type: 'item',
    //   url: '/onm/outputctrl',
    //   icon: icons.TuneOutlinedIcon,
    //   breadcrumbs: false
    // }
  ]
};

export default onm;
